import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import { useDeviceType } from "@/hooks/useDeviceType";

const ToolCard = props => {
  const { fields } = props || {};
  const {
    description = "",
    title = "",
    showReverse = false,
    image = {},
    ctas = {},
  } = fields || {};

  const { isBelow, isAbove, width } = useDeviceType(480);

  const reverseClass = showReverse && isAbove ? "flex-row-reverse" : "";
  const toolBoxClass = isBelow ? "flex-col" : `${reverseClass} flex-row`;
  const ImagBeoxClass = isBelow ? "w-full" : "w-[400px]";
  const buttonClick = url => {
    window.open(url, "_blank");
  };

  if (width === null) return;
  return (
    <div className={`row koh-top-row flex flex-row w-full `}>
      <div className="card-section flex  flex-col gap-0 md:gap-6 w-full">
        <hr className="border-gray-300 flex-grow line" />

        <div className={`${toolBoxClass} flex w-full gap-4`}>
          <div
            className={`image-wrapper relative flex flex-col gap-5 max-md:w-full`}
          >
            <Image
              src={image?.fields?.src}
              alt={image?.fields?.alt}
              width={300}
              height={232}
              className={`object-cover image-section ${ImagBeoxClass}`}
            />
          </div>
          <div className="article-button-section flex flex-col gap-4 w-full">
            {title && (
              <p className="articleHeading mb-1 text-lg md:text-2xl leading-none font-normal lg:font-semibold text-[#232323]">
                {title}
              </p>
            )}
            {description ? (
              <div className="koh-pro-toolbox-text-body">
                <p className="font-normal break-words">{description}</p>
              </div>
            ) : null}
            <div className=" flex w-full">
              <button
                onClick={() => buttonClick(ctas?.[0]?.fields?.url)}
                class="px-4 py-2 text-md text-[#FFF] md:text-lg bg-black w-[140px] button text-white font-semibold text-base rounded hover:bg-[#bebebe] hover:!text-[#000] hover:text-white transition"
              >
                {ctas?.[0]?.fields?.label}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolCard;
